/* Gassas shared product feed + product card (assets/gassas-feed.js).
   Used by the finder (collection pages), note profile pages and the product page rows.
   Needs assets/doftfinder-notes.js first. */
(function () {
  'use strict';
  var G = window.GassasNotes;
  if (!G || window.GassasFeed) return;

  var lang = String(document.documentElement.lang || 'sv').slice(0, 2) === 'sv' ? 'sv' : 'en';
  var code = String(document.documentElement.lang || 'sv').slice(0, 2).toLowerCase();
  var txtLang = code === 'da' ? 'da' : (code === 'nb' || code === 'no' || code === 'nn') ? 'nb' : lang;
  var TXT = {
    sv: { from: 'Från', unavailable: 'Slower Delivery Items', rating: 'Betyg' },
    da: { from: 'Fra', unavailable: 'Slower Delivery Items', rating: 'Bedømmelse' },
    nb: { from: 'Fra', unavailable: 'Slower Delivery Items', rating: 'Vurdering' },
    en: { from: 'From', unavailable: 'Slower Delivery Items', rating: 'Rating' }
  };
  var T = TXT[txtLang];
  var SRC = { top: 'nt', heart: 'nh', base: 'nb' };
  var QUOT = String.fromCharCode(34);
  var notes = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').split(QUOT).join('&quot;');
  }

  function handleOf(u) {
    var m = String(u || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  /* raw feed row -> product with classified notes */
  function normalize(p) {
    var vendor = p.v || '';
    var name = p.t || '';
    if (vendor && name.indexOf(vendor) === 0) {
      var rest = name.slice(vendor.length).replace(/^[ -]+/, '');
      if (rest) name = rest;
    }
    var o = {
      u: p.u, h: handleOf(p.u), t: p.t || '', name: name, v: vendor, p: p.p || 0, pt: p.pt || '', pv: !!p.pv, a: p.a !== false,
      img: p.i || '', au: p.au || '', c: p.c || '', r: parseFloat(p.r) || 0,
      f: Array.isArray(p.f) ? p.f : [],
      tiers: { top: {}, heart: {}, base: {} }, all: {}, has: false
    };
    ['top', 'heart', 'base'].forEach(function (tier) {
      var list = p[SRC[tier]];
      if (!Array.isArray(list)) return;
      list.forEach(function (rawNote) {
        var n = G.classify(rawNote);
        if (!notes[n.id]) notes[n.id] = n;
        o.tiers[tier][n.id] = 1;
        o.all[n.id] = 1;
        o.has = true;
      });
    });
    return o;
  }

  /* one product card; extra is optional html placed after the meta row (e.g. a match badge) */
  function card(p, extra) {
    var price = p.pv ? T.from + ' ' + p.pt : p.pt;
    if (!p.a) price += ' · ' + T.unavailable;
    var img = p.img ? "<img src='" + esc(p.img) + "' alt='' width='480' height='600' loading='lazy'>" : '';
    var rating = p.r ? "<span class='df-card__rating'><span aria-hidden='true'>★ </span>" + p.r.toFixed(1) + "<span class='df-sr'> " + esc(T.rating) + "</span></span>" : '';
    return "<li class='df-card'><a class='df-card__link' href='" + esc(p.u) + "'><span class='df-card__media'>" + img + "</span>" +
      "<span class='df-card__vendor'>" + esc(p.v) + "</span><span class='df-card__title'>" + esc(p.name) + "</span>" +
      "<span class='df-card__meta'><span class='df-card__price'>" + esc(price) + "</span>" + rating + "</span>" + (extra || '') + "</a></li>";
  }

  /* feed endpoint: templates/collection.doftdata.liquid -> /collections/all?view=doftdata (cached per tab) */
  var KEY = 'gassas.feed.v2:' + G.root();
  function fromCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY));
      if (c && c.d && Date.now() - c.t < 900000) return c.d;
    } catch (e) { /* ignore */ }
    return null;
  }
  function toCache(d) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* ignore */ }
  }
  var pending = null;
  function load() {
    if (pending) return pending;
    pending = new Promise(function (resolve, reject) {
      var cached = fromCache();
      if (cached) { resolve(cached.map(normalize)); return; }
      fetch(G.root() + 'collections/all?view=doftdata', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
        .then(function (t) {
          var a = t.indexOf('@@GF@@');
          var b = t.indexOf('@@/GF@@');
          if (a < 0 || b < 0) throw new Error('feed format');
          var d = JSON.parse(t.slice(a + 6, b));
          toCache(d);
          resolve(d.map(normalize));
        })
        .catch(reject);
    });
    return pending;
  }

  window.GassasFeed = {
    lang: lang, T: T, esc: esc, handleOf: handleOf, normalize: normalize, card: card, load: load, notes: notes
  };
})();
